import React, { Component } from "react";
import FlagIconFactory from "react-flag-icon-css";

const FlagIcon = FlagIconFactory(React, { useCssModules: false });
const queryString = require("query-string");

export default class OrdersRanking extends Component {
  constructor(props){
    super(props);
  }  
  
  eachOrders = (item, index) => {
    let query = queryString.parse(window.location.search);
    if (item.yesterday.percent === 0 && item.yesterday.count !== 0) {
      item.yesterday.percent = item.yesterday.count > 0 ? 1 : -1;
    }
    if (item.lastWeek.percent === 0 && item.lastWeek.count !== 0) {
      item.lastWeek.percent = item.lastWeek.count > 0 ? 1 : -1;
    }
    if (item.lastYear.percent === 0 && item.lastYear.count !== 0) {
      item.lastYear.percent = item.lastYear.count > 0 ? 1 : -1;
    }
    const y = item.yesterday.percent;
    const w = item.lastWeek.percent;
    const ye = item.lastYear.percent;
    let yesterdayClass;
    let pastWeekClass;
    let pastYearClass;

    if (y < -66) {
      yesterdayClass = "bg-dark-red";
    } else if (y < -33) {
      yesterdayClass = "bg-red";
    } else if (y < 0) {
      yesterdayClass = "bg-light-red";
    } else if (!y || y === 0) {
      yesterdayClass = "bg-white-40";
    } else if (y < 33) {
      yesterdayClass = "bg-light-green";
    } else if (y < 66) {
      yesterdayClass = "bg-green";
    } else {
      yesterdayClass = "bg-dark-green";
    }

    if (w < -66) {
      pastWeekClass = "bg-dark-red";
    } else if (w < -33) {
      pastWeekClass = "bg-red";
    } else if (w < 0) {
      pastWeekClass = "bg-light-red";
    } else if (!w || w === 0) {
      pastWeekClass = "bg-white-40";
    } else if (w < 33) {
      pastWeekClass = "bg-light-green";
    } else if (w < 66) {
      pastWeekClass = "bg-green";
    } else {
      pastWeekClass = "bg-dark-green";
    }

    if (ye < -66) {
      pastYearClass = "bg-dark-red";
    } else if (ye < -33) {
      pastYearClass = "bg-red";
    } else if (ye < 0) {
      pastYearClass = "bg-light-red";
    } else if (!ye || ye === 0) {
      pastYearClass = "bg-white-40";
    } else if (ye < 33) {
      pastYearClass = "bg-light-green";
    } else if (ye < 66) {
      pastYearClass = "bg-green";
    } else {
      pastYearClass = "bg-dark-green";
    }

    // Original color scheme: (item.pastWeek.percent < 0 ? "bg-red" : "bg-green")
    return (
      <tr key={ this.props.name + "_" + item.position } className="tc bg-dark-violet">
        <td headers="ranking" className="dtc pv1 pv0-l ph2 fw8 w-10">
          { item.position || "#0" }
        </td>
        <td headers="country" className={ "pv1 pv0-l ph1 w-10" + (query.showCountry === "false" || this.props.name === 'Segment' || this.props.name === 'Squad' ? ' dn' : ' dtc') }>
          { item.flag !== "NOT_FOUND" ? <FlagIcon code={ item.flag } /> : false }
        </td>
        <td headers="account" className="dtc pv1 pv0-l ph3 w-10">
          { item.name }
        </td>
        <td headers="ordersToday" className="dtc pv1 pv0-l ph3 fw8 f4 w-10">
          { item.now.count }
        </td>
        <td
          headers="ordersYesterday"
          className={ "dtc pv1 pv0-l ph3 w-20 " + yesterdayClass }
        >
          <span className="fw8 f5">{ item.yesterday.count }</span>{ " " }
          <small className="db f8">
            { item.yesterday.percent }
            { item.yesterday.percent ? " %" : null }
          </small>
        </td>
        <td
          headers="ordersLastWeek"
          className={ "dtc pv1 pv0-l ph3 w-20 " + pastWeekClass }
        >
          <span className="fw8 f5">{ item.lastWeek.count }</span>{ " " }
          <small className="db f8">
            { item.lastWeek.percent }
            { item.lastWeek.percent ? " %" : null }
          </small>
        </td>
        { this.props.show_last_year ?
        (<td
          headers="ordersLastYear"
          className={ "dtc pv1 pv0-l ph3 w-20 " + pastYearClass }
        >
          <span className="fw8 f5">{ item.lastYear.count }</span>{ " " }
          {
          item.lastYear.percent > 0 ?
          <small className="db f8">
            { item.lastYear.percent }
            { item.lastYear.percent ? " %" : null }
          </small>
          : null
          }
        </td>)
        : null }
      </tr>
    );
  };
  eachValues = (item, index) => {
    let query = queryString.parse(window.location.search);
    if (item.yesterday.valuePercent === 0 && item.yesterday.count !== 0) {
      item.yesterday.valuePercent = item.yesterday.count > 0 ? 1 : -1;
    }
    if (item.lastWeek.valuePercent === 0 && item.lastWeek.count !== 0) {
      item.lastWeek.valuePercent = item.lastWeek.count > 0 ? 1 : -1;
    }
    if (item.lastYear.valuePercent === 0 && item.lastYear.count !== 0) {
      item.lastYear.valuePercent = item.lastYear.count > 0 ? 1 : -1;
    }
    const y = item.yesterday.valuePercent;
    const w = item.lastWeek.valuePercent;
    const ye = item.lastYear.valuePercent;
    let yesterdayClass;
    let pastWeekClass;
    let pastYearClass;

    if (y < -66) {
      yesterdayClass = "bg-dark-red";
    } else if (y < -33) {
      yesterdayClass = "bg-red";
    } else if (y < 0) {
      yesterdayClass = "bg-light-red";
    } else if (!y || y === 0) {
      yesterdayClass = "bg-white-40";
    } else if (y < 33) {
      yesterdayClass = "bg-light-green";
    } else if (y < 66) {
      yesterdayClass = "bg-green";
    } else {
      yesterdayClass = "bg-dark-green";
    }

    if (w < -66) {
      pastWeekClass = "bg-dark-red";
    } else if (w < -33) {
      pastWeekClass = "bg-red";
    } else if (w < 0) {
      pastWeekClass = "bg-light-red";
    } else if (!w || w === 0) {
      pastWeekClass = "bg-white-40";
    } else if (w < 33) {
      pastWeekClass = "bg-light-green";
    } else if (w < 66) {
      pastWeekClass = "bg-green";
    } else {
      pastWeekClass = "bg-dark-green";
    }

    if (ye < -66) {
      pastYearClass = "bg-dark-red";
    } else if (ye < -33) {
      pastYearClass = "bg-red";
    } else if (ye < 0) {
      pastYearClass = "bg-light-red";
    } else if (!ye || ye === 0) {
      pastYearClass = "bg-white-40";
    } else if (ye < 33) {
      pastYearClass = "bg-light-green";
    } else if (ye < 66) {
      pastYearClass = "bg-green";
    } else {
      pastYearClass = "bg-dark-green";
    }

    // Original color scheme: (item.pastWeek.percent < 0 ? "bg-red" : "bg-green")
    return (
      <tr key={ this.props.name + "_" + item.position } className="tc bg-dark-violet">
        <td headers="ranking" className="dtc pv1 pv0-l ph2 fw8 w-10">
          { item.position || "#0" }
        </td>
        <td headers="country" className={ "pv1 pv0-l ph1 w-10" + (query.showCountry === "false" || this.props.name === 'Segment' || this.props.name === 'Squad' ? ' dn' : ' dtc') }>
          { item.flag !== "NOT_FOUND" ? <FlagIcon code={ item.flag } /> : false }
        </td>       
        <td headers="account" className="dtc pv1 pv0-l ph3 w-10">
          { item.name }
        </td>
        <td headers="ordersToday" className="dtc pv1 pv0-l ph3 fw8 f4 w-10">
          { item.now.value }
        </td>
        <td
          headers="ordersYesterday"
          className={ "dtc pv1 pv0-l ph3 w-20 " + yesterdayClass }
        >
          <span className="fw8 f5 mr3-xl">{ item.yesterday.value }</span>{ " " }
          <span>
            { item.yesterday.valuePercent }
            { item.yesterday.valuePercent ? " %" : null }
          </span>
        </td>
        <td
          headers="ordersLastWeek"
          className={ "dtc pv1 pv0-l ph3 w-20 " + pastWeekClass }
        >
          <span className="fw8 f5 mr3-xl">{ item.lastWeek.value }</span>{ " " }
          <span>
            { item.lastWeek.valuePercent }
            { item.lastWeek.valuePercent ? " %" : null }
          </span>
        </td>
        {
          this.props.show_last_year ?
          (
        <td
          headers="ordersLastYear"
          className={ "dtc pv1 pv0-l ph3 w-20 " + pastYearClass }
        >
          <span className="fw8 f5 mr3-xl">{ item.lastYear.value }</span>{ " " }
          <span>
            { item.lastYear.valuePercent }
            { item.lastYear.valuePercent ? " %" : null }
          </span>
        </td>
          ) : null
        }
        
      </tr>
    );
  };
  render() {
    const query = queryString.parse(window.location.search);
    return (
        <div>
          {
            this.props.loaded
            ? (<div>
              <h3 className="mv0 f3 fw1 tc pv4 dn-l"> Top Accounts</h3>
              <div className="pa0 mt4-l">
                  <div className="overflow-x-scroll overflow-hidden-l f6 ph2-l flex-l justify-around w-100">
                      <table className="fl w-100 w-50-l mr0 mr2-l">
                          <thead className="w4 white-70 dt-row-group-l">
                              <tr className="w-100">
                              <th id="ranking" className="w-10 fw4">
                                  #
                              </th>
                              <th id="country" className={ "w-10 fw4" + (query.showCountry === "false" || this.props.name === 'Segment' || this.props.name === 'Squad' ? ' dn' : '') }>
                                  Country
                              </th>
                              <th id="name" className="w-10 fw4">
                                  {this.props.name}
                              </th>
                              <th id="ordersToday" className="w-10 fw4">
                                  Today
                              </th>
                              <th id="ordersYesterday" className="w-20 fw4">
                                  Yesterday
                              </th>
                              <th id="ordersLastWeek" className="w-20 fw4">
                                  Last Week
                              </th>
                              { this.props.show_last_year ?
                              (<th id="ordersLastYear" className="w-20 fw4">
                                Last Year
                              </th>) : null
                              }
                              </tr>
                          </thead>
                          <tbody className="lh-copy">
                              { this.props.columns.c1.map(query.mode === "values" ? this.eachValues : this.eachOrders) }
                          </tbody>
                      </table>
                      <table className="fl w-100 w-50-l mr0 mr2-l">
                          <thead className="w4 white-70 dt-row-group-l dn">
                              <tr className="w-100">
                              <th id="ranking" className="w-10 fw4">
                                  #
                              </th>
                              <th id="country" className={ "w-10 fw4" + (query.showCountry === "false" || this.props.name === 'Segment' || this.props.name === 'Squad' ? ' dn' : '') }>
                                  Country
                              </th>
                              <th id="name" className="w-10 fw4">
                                  {this.props.name}
                              </th>
                              <th id="ordersToday" className="w-10 fw4">
                                  Today
                              </th>
                              <th id="ordersYesterday" className="w-20 fw4">
                                  Yesterday
                              </th>
                              <th id="ordersLastWeek" className="w-20 fw4">
                                  Last Week
                              </th>
                              { this.props.show_last_year ?
                              (<th id="ordersLastYear" className="w-20 fw4">
                                Last Year
                              </th>) : null
                              }
                              </tr>
                          </thead>
                          <tbody className="lh-copy">
                              { this.props.columns.c2.map(
                              query.mode === "values" ? this.eachValues : this.eachOrders
                              ) }
                          </tbody>
                      </table>
                  </div>
              </div>
            </div>)
            : ''
          }
        </div>          
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersRanking/index.js